<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 32 32" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
    <path d="M27.17,48a3.39,3.39,0,0,1,.62-1.79L38,33c.34-.44.18-.79-.38-.79h-26c-.55,0-.72.35-.38.79l10.26,13.2A3.39,3.39,0,0,1,22.17,48V63.17a.63.63,0,0,0,.93.63l3.14-1.26a1.58,1.58,0,0,0,.93-1.37Zm2,0V61.17A3.58,3.58,0,0,1,27,64.4l-3.14,1.26a2.62,2.62,0,0,1-3.67-2.49V48a1.67,1.67,0,0,0-.2-.57L9.71,34.19a2.42,2.42,0,0,1,2-4h26a2.42,2.42,0,0,1,2,4L29.36,47.39A1.66,1.66,0,0,0,29.17,48Z"
          transform="translate(-9.11 -30.17)"/>
    </svg>
</template>

<script>
    export default {
        name: "FilterEmptyIcon",
        props: {
            width: {
                type: [Number, String],
                default: 10
            },
            height: {
                type: [Number, String],
                default: 16
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>